import type { VesselReservationFragment } from '../../graphql';
import {
  useAllVesselReservationsQuery,
  useVesselReservationUpdatedSubscription,
} from '../../graphql';
import { isDefined } from '../../lib/util';
import { useMemo } from 'react';

export function useVesselReservations(organization_id: number | null) {
  const { data, refetch } = useAllVesselReservationsQuery();
  useVesselReservationUpdatedSubscription({
    variables: {
      org: (organization_id ?? -1).toString(),
    },
    skip: typeof window === 'undefined' || !organization_id,
    onData: async function () {
      await refetch();
    },
  });
  return useMemo(() => {
    const vesselReservations: VesselReservationFragment[] =
      data?.allVesselReservations?.nodes.filter(isDefined) ?? [];

    const reservedVessels = new Set<number>();
    vesselReservations.forEach((op) => reservedVessels.add(op.vesselId));

    return { vesselReservations, reservedVessels };
  }, [data?.allVesselReservations]);
}
